import type { Catalogo } from "../index.ts";
import { attivita } from "./attivita.ts";
import { avvio } from "./avvio.ts";
import { comune } from "./comune.ts";
import { compose } from "./compose.ts";
import { editor } from "./editor.ts";
import { email } from "./email.ts";
import { errori } from "./errori.ts";
import { guscio } from "./guscio.ts";
import { impostazioni } from "./impostazioni.ts";
import { log } from "./log.ts";
import { pagine } from "./pagine.ts";
import { rilascio } from "./rilascio.ts";
import { rilascioUi } from "./rilascioUi.ts";
import { risorse } from "./risorse.ts";
import { stack } from "./stack.ts";

/** Il catalogo inglese: stesse chiavi dell'italiano, ogni area nel suo file. */
export const en: Catalogo = {
  ...attivita,
  ...avvio,
  ...comune,
  ...compose,
  ...editor,
  ...email,
  ...errori,
  ...guscio,
  ...impostazioni,
  ...log,
  ...pagine,
  ...rilascio,
  ...rilascioUi,
  ...risorse,
  ...stack,
};
